import { Edit24, Delete24 } from 'ui/icons';
import { BUTTON_SIZES } from 'ui/button';
import { OverflowMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import { useModalsContext } from 'modules/sendingPlatforms/contexts';
import noop from 'utils/noop';

export const DestinationOverflowMenu = () => {
  const { showDeleteDestinationModal } = useModalsContext();

  const options = [
    {
      id: 'edit-destination',
      label: 'Edit',
      content: (
        <>
          <Edit24></Edit24>
          Edit
        </>
      ),
      onClick: noop,
      as: AllowedActionMenuElements.Button,
    },
    {
      id: 'delete-destination',
      label: 'Delete',
      content: (
        <>
          <Delete24 />
          Delete
        </>
      ),
      onClick: showDeleteDestinationModal,
      as: AllowedActionMenuElements.Button,
    },
  ];

  return (
    <OverflowMenu id="destination-overflow-menu" options={options} size={BUTTON_SIZES.LARGE} />
  );
};
